(function (module) {
    "use strict";

    module.component('skipPeriods', {
        template: require('./skipPeriodsComponent.html'),
        bindings: {
            labels: "<",
            parameters: "<",
            enter: '=',
            forecast: "=",
            isEditable: "<"
        },
        controller: ['$scope', 'ChartsConfig', 'skipPeriodsService', '$timeout',
            function(
                this: $TSFixMe,
                $scope: $TSFixMe,
                ChartsConfig: $TSFixMe,
                skipPeriodsService: $TSFixMe,
                $timeout: ng.ITimeoutService
            ) {
                var $ctrl = this;

                $ctrl.specialDatasetOverride = ChartsConfig.specialDatasetOverride;
                $ctrl.options = ChartsConfig.options;
                $ctrl.options.legend = { display: false };

                function generateChartData() {

                    if (angular.isUndefinedOrNull($ctrl.forecast))
                        return;
                    $ctrl.chartArray = [
                        $ctrl.forecast.dataAfterSkipped ? $ctrl.forecast.dataAfterSkipped : $ctrl.forecast.dataAfterCorrection,
                        $ctrl.forecast.dataAfterCorrection
                    ];
                }


                $scope.$watchGroup(['$ctrl.forecast.dataAfterSkipped', '$ctrl.forecast.dataAfterCorrection'], function () {
                    generateChartData();
                });

                $ctrl.startSliderDone = function () {
                    $ctrl.forecast.skippedStart = $ctrl.skippedStart;
                    skipPeriods();
                }

                $ctrl.endSliderDone = function () {
                    $ctrl.forecast.skippedEnd = $ctrl.skippedEnd;
                    skipPeriods();
                }

                $ctrl.skipStartChanged = () => {
                    skipPeriods();
                }

                $ctrl.skipEndChanged = () => {
                    skipPeriods();
                }
                $ctrl.isMachineLearningPrediction = () => {
                   return $ctrl.forecast.regression==="machine_learning";
                }

                function skipPeriods() {
                    if($ctrl.isEditable){
                        skipPeriodsService.skip($ctrl.forecast, $ctrl.parameters, $ctrl.forecast.skippedStart, $ctrl.forecast.skippedEnd);
                    }
                }

                $ctrl.$onInit = function () {
                    $ctrl.enter = function () {
                        $ctrl.rangeMax = $ctrl.labels.length - 1;
                        generateChartData();
                        if ($ctrl.forecast) {
                            $ctrl.skippedStart = $ctrl.forecast.skippedStart;
                            $ctrl.skippedEnd = $ctrl.forecast.skippedEnd;
                        }
                        $timeout(function () {
                            $scope.$broadcast('rzSliderForceRender')
                        });
                    };
                };
            }]
    });

})(angular.module('topline.modules'));